<script setup lang="ts">
import { computed, ref } from 'vue';
import ClearAndRestartModal from '@/shared/infrastructure/components/ClearAndRestartModal.vue';
import ConsentSaveAndExitModal from '@/consent/medicare/infrastructure/components/ConsentSaveAndExitModal.vue';

const props = defineProps<{
  currentSection: number;
}>();

interface EmitsInterface {
  (event: 'saveAndExit'): void;
  (event: 'clearAndRestart'): void;
}

const emits = defineEmits<EmitsInterface>();

const saveAndExitModal = ref(false);

const saveAndExitLabel = computed(() => props.currentSection === 0 ? 'Save & Exit' : 'Send to Medicare Beneficiary');

const saveAndExitTooltip = 'If you are helping a friend or family member, but don\'t have Power of Attorney, they need to read and agree to the disclosure themselves. Use this link to send it to the Medicare Beneficiary.';

const open = (): void => {
  saveAndExitModal.value = true;
};

defineExpose({
  open,
});
</script>
<template>
  <div class="flex flex-col items-center mt-1">
    <div class="flex items-center text-center mt-1">
      <a @click="emits('saveAndExit')" class="text-sm text-blue-600 cursor-pointer font-medium hover:underline" v-html="saveAndExitLabel"></a>
      <hfc-icon v-if="currentSection !== 0" icon="circle-info" class="ml-2 text-blue-500 inline-block w-3 h-3" v-tooltip="{ content: saveAndExitTooltip, popperClass: 'w-52' }" />
    </div>
    <ClearAndRestartModal @confirm="emits('clearAndRestart')" />
  </div>
  <ConsentSaveAndExitModal v-if="saveAndExitModal" @close="saveAndExitModal = false" />
</template>
